import type { LegacyProductFlag } from './productFlags.type';

export const DARKLY_PRODUCT_FLAGS = {
  ADS: 'flag-00000113',
  ADVANCED_COMPLIANCE: 'flag-00000121',
  DATA_FEEDS_ESSENTIALS: 'flag-00000128',
  DEEPVIEWS_PRO: 'flag-00000112',
  EMAIL_ESSENTIALS: 'flag-00000105',
  ENGAGEMENT_BUILDER: 'flag-00000108',
  EXPORT_APIS_ESSENTIALS: 'flag-00000129',
  EXPORT_DATA_INTEGRATIONS: 'flag-00000124',
  HOUSEHOLD_CTV: 'flag-00000107',
  INSTALL_TOUCH_ATTRIBUTION: 'flag-00000114',
  JOURNEYS_ESSENTIALS: 'flag-00000106',
  JOURNEYS_PRO: 'flag-00000111',
  MULTI_TOUCH_SAN: 'flag-00000115',
  PARTNER_MANAGEMENT_PRO: 'flag-00000117',
  QR_CODES_ESSENTIALS: 'flag-00000104',
  QR_CODES_PRO: 'flag-00000110',
  QUICK_LINKS: 'flag-00000103',
  ROI_HUB: 'flag-00000116',
  SEO: 'flag-00000119',
  SSO: 'flag-00000118',
  WEBHOOKS: 'flag-00000123',
  LINK_SHORTENER_V1: 'flag-00000137',
  DISALLOW_APP_CREATION: 'flag-00000141',
  DISALLOW_AGENCY_MANAGEMENT: 'flag-00000142',
  DISALLOW_CUSTOM_DOMAIN: 'flag-00000143',
} as const;
export type DarklyProductFlag = (typeof DARKLY_PRODUCT_FLAGS)[keyof typeof DARKLY_PRODUCT_FLAGS];

/**
 * Legacy Product Flags
 */
export const LEGACY_AD_LINK_MANAGER = 'ad_link_manager';
export const LEGACY_AD_LINK_TEMPLATES = 'ad_link_templates';
export const LEGACY_BULK_AD_LINKS = 'bulk_ad_links';
export const LEGACY_BULK_QUICK_LINKS = 'bulk_quick_links';
export const LEGACY_QUICK_LINK_MANAGER = 'quick_link_manager';
export const LEGACY_QUICK_LINK_TEMPLATES = 'quick_link_templates';
export const LEGACY_SEO_APP_ATTRIBUTION = 'seo_app_attribution';
export const LEGACY_QUICK_LINK_ANALYTICS = 'quick_link_analytics';
export const LEGACY_LINK_CREATE_EDIT_TRACK = 'link_create_edit_track';
export const LEGACY_SSO_BASIC = 'sso_basic';
export const LEGACY_PROTECTED_API = 'protected_api';
export const LEGACY_CUSTOM_QR_CODES_UI = 'custom_qr_codes_ui';
export const LEGACY_CUSTOM_QR_CODES = 'custom_qr_codes';
export const LEGACY_ADS_ATTRIBUTION_TIER_1 = 'ads_attribution_tier_1';
export const LEGACY_ADS_ATTRIBUTION_TIER_2 = 'ads_attribution_tier_2';
export const LEGACY_ADS_ATTRIBUTION_TIER_3 = 'ads_attribution_tier_3';
export const LEGACY_ROI_HUB = 'roi_hub';
export const LEGACY_HOUSEHOLD = 'household_measurement';

export enum LegacyProductSuite {
  ESSENTIALS = 'ESSENTIALS',
  ESSENTIALS_WITH_UNIVERSAL_ADS = 'ESSENTIALS_WITH_UNIVERSAL_ADS',
  LINKHUB = 'LINKHUB',
  LINKHUB_WITH_UNIVERSAL_ADS = 'LINKHUB_WITH_UNIVERSAL_ADS',
}

/**
 * Set of all Legacy PPP features
 */
export const LEGACY_PRODUCT_FLAGS = new Set<LegacyProductFlag>([
  LEGACY_AD_LINK_MANAGER,
  LEGACY_AD_LINK_TEMPLATES,
  LEGACY_BULK_AD_LINKS,
  LEGACY_BULK_QUICK_LINKS,
  LEGACY_QUICK_LINK_MANAGER,
  LEGACY_QUICK_LINK_TEMPLATES,
  LEGACY_SEO_APP_ATTRIBUTION,
  LEGACY_SSO_BASIC,
  LEGACY_PROTECTED_API,
  LEGACY_CUSTOM_QR_CODES_UI,
  LEGACY_ADS_ATTRIBUTION_TIER_1,
  LEGACY_ADS_ATTRIBUTION_TIER_2,
  LEGACY_ADS_ATTRIBUTION_TIER_3,
]);

export const LEGACY_PRODUCT_SUITE_FLAGS: Record<LegacyProductSuite, LegacyProductFlag[]> = {
  [LegacyProductSuite.ESSENTIALS]: [LEGACY_QUICK_LINK_MANAGER],
  [LegacyProductSuite.ESSENTIALS_WITH_UNIVERSAL_ADS]: [LEGACY_QUICK_LINK_MANAGER, LEGACY_AD_LINK_MANAGER],
  [LegacyProductSuite.LINKHUB]: [LEGACY_QUICK_LINK_MANAGER, LEGACY_QUICK_LINK_TEMPLATES, LEGACY_BULK_QUICK_LINKS],
  [LegacyProductSuite.LINKHUB_WITH_UNIVERSAL_ADS]: [
    LEGACY_QUICK_LINK_MANAGER,
    LEGACY_QUICK_LINK_TEMPLATES,
    LEGACY_BULK_QUICK_LINKS,
    LEGACY_AD_LINK_MANAGER,
    LEGACY_AD_LINK_TEMPLATES,
    LEGACY_BULK_AD_LINKS,
  ],
};
